
//去除数字里面的空值 
export function trimSpace(array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] == "" || array[i] == null || typeof (array[i]) == "undefined") {
      array.splice(i, 1);
      i = i - 1;
    }
  }
  return array;
}


// WEBPACK FOOTER //
// ./src/utils/encapsulationMethod.js